import countries from './countries.json';
import { sanitizeIban, mod97 } from './helpers.js';

const codeA = 'A'.charCodeAt(0);

function validateIban(str) {
  if (!str) {
    return true;
  }
  const iban = sanitizeIban(str);
  return validateNumber(iban) && validateCountry(iban) && validateChecksum(iban);
}

function validateNumber(iban) {
  const number = parseInt(iban.slice(2, 4), 10);
  return number >= 2 && number <= 98;
}

function validateCountry(iban) {
  const code = iban.substring(0, 2);
  const info = countries[code];
  if (!info) {
    return false;
  }
  const regex = new RegExp(info['IBAN regexp']);
  const result = regex.test(iban);
  return result;
}

function validateChecksum(iban) {
  const rest = iban.slice(4) + iban.slice(0, 4);
  const replacer = (str) => (str.charCodeAt(0) - codeA + 10).toString();
  const transformed = rest.replace(/[A-Z]/g, replacer);
  const result = mod97(transformed);
  return result === 1;
}

export default validateIban;
